import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { CreateFormDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export default function NewSurveyTemplatePage() {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { company, access } = useCurrentSession()
  const creating = useRef(false)

  const [createForm] = useMutation(CreateFormDocument, {
    extractorFn: (data) => data.formsMutations.createFormsForm,
  })

  useEffect(() => {
    if (creating.current) return
    creating.current = true

    const create = async () => {
      if (!company?.id || !access?.id) return

      const result = await createForm({
        variables: {
          anonymous: false,
          authorId: access.id,
          companyId: company.id,
          description: '',
          elements: [],
          formType: 'custom',
          resourceType: 'Surveys::Survey',
          status: 'draft',
          title: i18n.t('surveys.templates'),
        },
      })

      const handled = handleResult(result, () => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.error'),
        })
      })

      if (handled.success && handled.data?.form?.id) {
        navigate(
          navigation.engagement.smart_surveys.templates.id.fullPath({
            id: handled.data.form.id,
          }),
          { replace: true }
        )
      } else {
        navigate(navigation.engagement.smart_surveys.templates.fullPath(), { replace: true })
      }
    }

    create()
  }, [createForm, navigate, navigation, company, access])

  return <Loading expand />
}
